import { render, staticRenderFns } from "./OptimaMenu.vue?vue&type=template&id=101facce&scoped=true&"
import script from "./OptimaMenu.vue?vue&type=script&lang=js&"
export * from "./OptimaMenu.vue?vue&type=script&lang=js&"
import style0 from "./OptimaMenu.vue?vue&type=style&index=0&id=101facce&scoped=true&lang=css&"
import style1 from "./OptimaMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101facce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101facce')) {
      api.createRecord('101facce', component.options)
    } else {
      api.reload('101facce', component.options)
    }
    module.hot.accept("./OptimaMenu.vue?vue&type=template&id=101facce&scoped=true&", function () {
      api.rerender('101facce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Optima/OptimaMenu.vue"
export default component.exports